import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout, Row, Col, Input, Button, Spin } from 'antd';
import { Modal, Icon, LocaleProvider, DatePicker, List } from 'antd-mobile';
import enUS from 'antd-mobile/lib/locale-provider/en_US';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import LocalStorage from '../../utils/localStorage';
import { Markup } from 'interweave';
import Toast from 'antd-mobile/lib/toast';
import IdleTimer from 'react-idle-timer';

const { Content } = Layout;
const { TextArea } = Input;
const confirmAlert = Modal.alert;

@inject(
  'VersionStore',
  'templateStore',
  'CmsLanguageStore',
  'popupStore',
  'SingleListStore',
  'loginStore',
  'webSettingStore',
  'TransactionStore',
)
@observer
class SingleListConfirm extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount() {
    const roomNo = this.props.loginStore.getRoomNo();
    if (!roomNo) {
      this.props.history.push('/login');
    }

    this.props.loginStore.authenticateGuest().then(response => {
      if (!response) {
        this.props.history.push('/login');
      }
    });

    if (this.props.match.params.menuID !== undefined && this.props.match.params.languageID !== undefined && this.props.match.params.itemID !== undefined) {
      const menuID = this.props.match.params.menuID;
      const languageID = this.props.match.params.languageID;
      const itemID = this.props.match.params.itemID;

      this.props.templateStore.getActive();
      
      this.props.CmsLanguageStore.getActives().then(() => {
        this.props.webSettingStore.getData().then(() => {
          this.props.SingleListStore.getData(menuID, languageID).then(() => {
            if (this.props.SingleListStore.items.length === 0) {
              confirmAlert('', 'There is no item on this menu', [
                {
                  text: 'OK'
                }
              ]);
              this.props.history.push('/');
            } else {
              this.props.SingleListStore.getItem(parseInt(itemID));

              const { menu } = this.props.SingleListStore;

              if (menu) {
                if (menu.menuType) {
                  this.props.popupStore.getByModuleName(`${menu.menuType}_CONFIRM`).then(resp => {
                    const { activeTemplate } = this.props.templateStore;

                    if (activeTemplate) {
                      if (resp) {
                        if (resp.title) {
                          confirmAlert(
                            <div style={{
                              fontFamily: activeTemplate.templateSetting.label.fontFamily,
                              color: activeTemplate.templateSetting.label.color,
                              fontSize: activeTemplate.templateSetting.label.fontSize,
                              lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                            }}>
                              <span>{resp.title}</span>
                            </div>,
                            <div style={{
                              fontFamily: activeTemplate.templateSetting.text.fontFamily,
                              color: activeTemplate.templateSetting.text.color,
                              fontSize: activeTemplate.templateSetting.text.fontSize,
                              lineHeight: `${activeTemplate.templateSetting.text.fontSize + 8}px`
                            }}>
                              <Markup content={resp.description} />
                            </div>,
                            [
                              {
                                text: <span style={{
                                  fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                  color: activeTemplate.templateSetting.label.color,
                                  fontSize: activeTemplate.templateSetting.label.fontSize,
                                  lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                }}>OK</span>
                              }
                            ]);
                        }
                      }
                    }
                  });
                }
              }
            }
          });
        });
      });
    } else {
      this.props.history.push('/');
    }
  }

  componentWillUnmount() {
    this.props.SingleListStore.resetData();
  }

  timeDeliverOnChange = (obj) => {
    const selectedDate = moment(obj.date).format('HH:mm');
    this.props.SingleListStore.settimeDeliver(selectedDate);
    this.props.SingleListStore.settimeDeliverDate(obj.date);
  }

  confirm = () => {
    this.props.TransactionStore.settransactionLoading(true);
    const roomNo = this.props.loginStore.getRoomNo();
    if (!roomNo) {
      this.props.history.push('/login');
    }

    this.props.loginStore.authenticateGuest().then(response => {
      if (!response) {
        this.props.history.push('/login');
      } else {
        const { activeTemplate } = this.props.templateStore;

        const {
          data: webSettting
        } = this.props.webSettingStore;

        const {
          menu,
          item,
          remark,
          timeSelected,
          timeDeliver
        } = this.props.SingleListStore;

        let scheduleTime = moment();
        if (timeDeliver === '') {
          if (timeSelected !== 'now') {
            if (timeSelected === '15mins') {
              scheduleTime.add(15, 'minutes');
            } else if (timeSelected === '30mins') {
              scheduleTime.add(30, 'minutes');
            } else if (timeSelected === '1hour') {
              scheduleTime.add(1, 'hours');
            }
          } else {
            scheduleTime = '';
          }
        } else {
          const localScheduleTime = `${moment().format('YYYY-MM-DD')} ${timeDeliver}:00`;
          scheduleTime = moment(localScheduleTime).utc();
        }

        let orders = [];
        let order = {
          'taskId': menu.taskId,
          'menuId': item.taskId,
          'scheduleTime': scheduleTime,
          'menuQuantity': 1,
          'remark': '',
          'amount': item.price
        };

        orders.push(order);

        const request = {
          'tenantId': LocalStorage.Get('companyId'),
          'roomNumber': LocalStorage.Get('roomNo'),
          'guestId': LocalStorage.Get('customerId'),
          'summaryRemark': remark,
          'data': orders
        };

        this.props.TransactionStore.create(request).then((resp) => {
          if (resp.success) {
            confirmAlert(
              <div
                style={{
                  fontFamily: activeTemplate.templateSetting.label.fontFamily,
                  color: activeTemplate.templateSetting.label.color,
                  fontSize: activeTemplate.templateSetting.label.fontSize,
                  lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                }}
              >
                <span>{webSettting.orderPopupTitleText}</span>
              </div>,
              <div
                style={{
                  fontFamily: activeTemplate.templateSetting.text.fontFamily,
                  color: activeTemplate.templateSetting.text.color,
                  fontSize: activeTemplate.templateSetting.text.fontSize,
                  lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`,
                  textAlign: 'center'
                }}
              >
                <span>{webSettting.orderPopupSuccessText}</span>
              </div>,
              [
                {
                  text:
                    <span
                      style={{
                        fontFamily: activeTemplate.templateSetting.label.fontFamily,
                        color: activeTemplate.templateSetting.label.color,
                        fontSize: activeTemplate.templateSetting.label.fontSize,
                        lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                      }}
                    >
                      {webSettting.backToHomeText}
                    </span>,
                  onPress: () => {
                    this.props.history.push('/');
                  }
                },
                {
                  text:
                    <span
                      style={{
                        fontFamily: activeTemplate.templateSetting.label.fontFamily,
                        color: activeTemplate.templateSetting.label.color,
                        fontSize: activeTemplate.templateSetting.label.fontSize,
                        lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                      }}
                    >
                      {webSettting.goToOrderText}
                    </span>,
                  onPress: () => {
                    this.props.history.push('/order');
                  }
                }
              ]);
          } else {
            confirmAlert(
              <div
                style={{
                  fontFamily: activeTemplate.templateSetting.label.fontFamily,
                  color: activeTemplate.templateSetting.label.color,
                  fontSize: activeTemplate.templateSetting.label.fontSize,
                  lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                }}
              >
                <span>Error</span>
              </div>,
              <div
                style={{
                  fontFamily: activeTemplate.templateSetting.text.fontFamily,
                  color: activeTemplate.templateSetting.text.color,
                  fontSize: activeTemplate.templateSetting.text.fontSize,
                  lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`,
                  textAlign: 'center'
                }}
              >
                <span>{webSettting.orderPopupFailedText}</span>
              </div>,
              [
                {
                  text:
                    <span
                      style={{
                        fontFamily: activeTemplate.templateSetting.label.fontFamily,
                        color: activeTemplate.templateSetting.label.color,
                        fontSize: activeTemplate.templateSetting.label.fontSize,
                        lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                      }}
                    >
                      OK
                    </span>
                }
              ]);
          }
        });
      }
    });
  }

  back = () => {
    this.props.history.push(`/single-list/${this.props.SingleListStore.menu.taskId}/language/${this.props.match.params.languageID}`);
  }

  checkSmVersion = () => {
    this.props.VersionStore.check().then(resp => {
      if (!resp) {
        const { activeTemplate } = this.props.templateStore;
        const { data: webSettting } = this.props.webSettingStore;

        confirmAlert(
          <div
            style={{
              fontFamily: activeTemplate.templateSetting.label.fontFamily,
              color: activeTemplate.templateSetting.label.color,
              fontSize: activeTemplate.templateSetting.label.fontSize,
              lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
            }}>
            <span>Info</span>
          </div>,
          <div
            style={{
              fontFamily: activeTemplate.templateSetting.text.fontFamily,
              color: activeTemplate.templateSetting.text.color, fontSize: activeTemplate.templateSetting.text.fontSize,
              lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`, textAlign: 'center'
            }}>
            <span>New version has been released. Please refresh the page.</span>
          </div>, [
          {
            text:
              <span
                style={{
                  fontFamily: activeTemplate.templateSetting.label.fontFamily,
                  color: activeTemplate.templateSetting.label.color,
                  fontSize: activeTemplate.templateSetting.label.fontSize,
                  lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                }}
              >
                {webSettting.okText}
              </span>,
            onPress: () => {
              window.location.reload(true);
            }
          }
        ]);
      }
    });
  }

  render() {
    const { activeTemplate } = this.props.templateStore;

    const { data: webSettting } = this.props.webSettingStore;

    const {
      menu,
      item,
      remark,
      timeSelected,
      timeDeliverDate,
      timeDeliver
    } = this.props.SingleListStore;

    const { transactionLoading } = this.props.TransactionStore;

    if (webSettting) {
      if (transactionLoading) {
        Toast.loading(<span style={{
          fontFamily: activeTemplate.templateSetting.text.fontFamily,
          fontSize: activeTemplate.templateSetting.text.fontSize,
          lineHeight: `${activeTemplate.templateSetting.text.fontSize + 2}px`
        }}>{webSettting.processingOrderLoadingText}</span>, 100, null, true);
      } else {
        Toast.hide();
      }
    }

    return (
      <>
        {
          activeTemplate
            ?
            <>
              <Layout className='stm-layout'>
                <IdleTimer ref={ref => { this.idleTimer = ref }} timeout={1000 * 5} onIdle={this.checkSmVersion} debounce={250} />
                <>
                  {
                    webSettting
                      ?
                      <>
                        <Content>
                          {/* Header */}
                          <>
                            <Row>
                              <Col
                                span={24}
                                className='stm-position-fixed stm-top-0 stm-z-index-100000 stm-max-width-500'
                                style={{
                                  fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                  background: activeTemplate.templateSetting.header.backgroundColor,
                                  color: activeTemplate.templateSetting.header.color,
                                  fontSize: activeTemplate.templateSetting.header.fontSize,
                                  lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                }}
                              >
                                <Row>
                                  <Col span={4} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50' onClick={this.back}>
                                    <Icon type='left' size='lg' color={activeTemplate.templateSetting.header.color} />
                                  </Col>
                                  <Col span={16} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50'>
                                    {menu ? menu.taskName : ''}
                                  </Col>
                                  <Col span={4} />
                                </Row>
                              </Col>
                            </Row>
                          </>

                          {/* Banner */}
                          <>
                            {
                              menu
                                ?
                                <>
                                  {
                                    menu.bannerUrl === null || menu.bannerUrl === ''
                                      ?
                                      <Row className='stm-margin-top-50' />
                                      :
                                      <>
                                        <Row className='stm-height-160 stm-margin-top-50 stm-background-size-100-percent'>
                                          <Col span={24} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-160'>
                                            <img src={menu.bannerUrl} alt='Icon' />
                                          </Col>
                                        </Row>
                                      </>
                                  }
                                </>
                                :
                                null
                            }
                          </>

                          {/* Body */}
                          <>
                            {
                              item
                                ?
                                <>
                                  <Row className='stm-margin-top-10 stm-background-white stm-padding-bottom-100'>
                                    <Col span={1} />
                                    <Col span={22}>
                                      {/* Task Name & Task Detail */}
                                      <>
                                        {/* Task Name */}
                                        <Row className='stm-margin-top-10 stm-margin-bottom-10'>
                                          <Col
                                            span={24}
                                            className='stm-margin-bottom-10 stm-margin-top-10 stm-padding-16 stm-text-align-center stm-border-radius-4'
                                            style={{
                                              fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                              fontSize: activeTemplate.templateSetting.buttonItem.fontSize,
                                              lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize + 2}px`,
                                              color: activeTemplate.templateSetting.buttonItemSelected.color,
                                              border: `1px solid ${activeTemplate.templateSetting.buttonItemSelected.borderColor}`,
                                              backgroundColor: activeTemplate.templateSetting.buttonItemSelected.backgroundColor
                                            }}
                                          >
                                            {item.taskName}
                                          </Col>
                                        </Row>

                                        {/* Description */}
                                        <>
                                          {
                                            item.taskDesc === ''
                                              ?
                                              null
                                              :
                                              <Row className='stm-padding-top-4 stm-padding-left-8 stm-padding-right-8 stm-padding-bottom-20'>
                                                <Col
                                                  span={24}
                                                  className='stm-task-description stm-border-width-1 stm-border-style-solid stm-border-color-white-two stm-border-radius-4 stm-padding-8'
                                                  style={{
                                                    fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                    fontSize: activeTemplate.templateSetting.buttonItem.fontSize - 2,
                                                    lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize}px`,
                                                    color: activeTemplate.templateSetting.buttonItem.color
                                                  }}
                                                >
                                                  <Markup content={item.taskDesc} />
                                                </Col>
                                              </Row>
                                          }
                                        </>
                                      </>

                                      {/* Remark */}
                                      <>
                                        <Row>
                                          <Col span={24}>
                                            <TextArea
                                              rows={3}
                                              value={remark}
                                              onChange={(e) => this.props.SingleListStore.setremark(e.target.value)}
                                              placeholder={webSettting.remarkText}
                                              className='stm-padding-8'
                                              style={{
                                                fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                color: activeTemplate.templateSetting.text.color,
                                                fontSize: activeTemplate.templateSetting.text.fontSize
                                              }}
                                            />
                                          </Col>
                                        </Row>
                                      </>

                                      {/* Preferred Time */}
                                      <>
                                        <Row>
                                          <Col span={24} className='stm-margin-top-24'>
                                            <Row>
                                              <Col
                                                span={24}
                                                className='stm-margin-bottom-16'
                                                style={{
                                                  fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                  color: activeTemplate.templateSetting.label.color,
                                                  fontSize: activeTemplate.templateSetting.label.fontSize,
                                                  lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                }}
                                              >
                                                {webSettting.preferredTimeText}
                                              </Col>
                                              <Col span={24} className=''>
                                                <Row>
                                                  {/* Now */}
                                                  <>
                                                    <Col span={6}>
                                                      <Row>
                                                        <Col
                                                          span={24}
                                                          className='stm-margin-bottom-8 stm-display-flex stm-align-items-center stm-justify-content-center stm-height-40'
                                                          onClick={timeSelected !== 'now' ? () => this.props.SingleListStore.settimeSelected('now') : null}
                                                          style={{
                                                            fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                            fontSize: activeTemplate.templateSetting.buttonItem.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize + 2}px`,
                                                            color: timeSelected === 'now' ? activeTemplate.templateSetting.buttonItemSelected.color : activeTemplate.templateSetting.buttonItem.color,
                                                            border: `1px solid ${timeSelected === 'now' ? activeTemplate.templateSetting.buttonItemSelected.borderColor : activeTemplate.templateSetting.buttonItem.borderColor}`,
                                                            backgroundColor: activeTemplate.templateSetting.buttonItem.backgroundColor
                                                          }}
                                                        >
                                                          {webSettting.preferredTimeNowText}
                                                        </Col>
                                                      </Row>
                                                    </Col>
                                                  </>

                                                  {/* 15 Minutes */}
                                                  <>
                                                    <Col span={9} className='stm-padding-left-8'>
                                                      <Row>
                                                        <Col
                                                          span={24}
                                                          className='stm-margin-bottom-8 stm-display-flex stm-align-items-center stm-justify-content-center stm-height-40'
                                                          onClick={timeSelected !== '15mins' ? () => this.props.SingleListStore.settimeSelected('15mins') : null}
                                                          style={{
                                                            fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                            fontSize: activeTemplate.templateSetting.buttonItem.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize + 2}px`,
                                                            color: timeSelected === '15mins' ? activeTemplate.templateSetting.buttonItemSelected.color : activeTemplate.templateSetting.buttonItem.color,
                                                            border: `1px solid ${timeSelected === '15mins' ? activeTemplate.templateSetting.buttonItemSelected.borderColor : activeTemplate.templateSetting.buttonItem.borderColor}`,
                                                            backgroundColor: activeTemplate.templateSetting.buttonItem.backgroundColor
                                                          }}
                                                        >
                                                          {webSettting.preferredTime15MinutesLaterText}
                                                        </Col>
                                                      </Row>
                                                    </Col>
                                                  </>

                                                  {/* 30 Minutes */}
                                                  <>
                                                    <Col span={9} className='stm-padding-left-8'>
                                                      <Row>
                                                        <Col
                                                          span={24}
                                                          className='stm-margin-bottom-8 stm-display-flex stm-align-items-center stm-justify-content-center stm-height-40'
                                                          onClick={timeSelected !== '30mins' ? () => this.props.SingleListStore.settimeSelected('30mins') : null}
                                                          style={{
                                                            fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                            fontSize: activeTemplate.templateSetting.buttonItem.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize + 2}px`,
                                                            color: timeSelected === '30mins' ? activeTemplate.templateSetting.buttonItemSelected.color : activeTemplate.templateSetting.buttonItem.color,
                                                            border: `1px solid ${timeSelected === '30mins' ? activeTemplate.templateSetting.buttonItemSelected.borderColor : activeTemplate.templateSetting.buttonItem.borderColor}`,
                                                            backgroundColor: activeTemplate.templateSetting.buttonItem.backgroundColor
                                                          }}
                                                        >
                                                          {webSettting.preferredTime30MinutesLaterText}
                                                        </Col>
                                                      </Row>
                                                    </Col>
                                                  </>

                                                  {/* 1 Hour */}
                                                  <>
                                                    <Col span={10} className=''>
                                                      <Row>
                                                        <Col
                                                          span={24}
                                                          className='stm-margin-bottom-8 stm-display-flex stm-align-items-center stm-justify-content-center stm-height-40'
                                                          onClick={timeSelected !== '1hour' ? () => this.props.SingleListStore.settimeSelected('1hour') : null}
                                                          style={{
                                                            fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                            fontSize: activeTemplate.templateSetting.buttonItem.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize + 2}px`,
                                                            color: timeSelected === '1hour' ? activeTemplate.templateSetting.buttonItemSelected.color : activeTemplate.templateSetting.buttonItem.color,
                                                            border: `1px solid ${timeSelected === '1hour' ? activeTemplate.templateSetting.buttonItemSelected.borderColor : activeTemplate.templateSetting.buttonItem.borderColor}`,
                                                            backgroundColor: activeTemplate.templateSetting.buttonItem.backgroundColor
                                                          }}
                                                        >
                                                          {webSettting.preferredTime1HourLaterText}
                                                        </Col>
                                                      </Row>
                                                    </Col>
                                                  </>

                                                  {/* Select Time */}
                                                  <>
                                                    <Col span={14} className='stm-padding-left-8'>
                                                      <Row>
                                                        <LocaleProvider locale={enUS}>
                                                          <DatePicker
                                                            mode='time'
                                                            value={timeDeliverDate}
                                                            locale={enUS}
                                                            onOk={date => this.timeDeliverOnChange({ date })}
                                                            onDismiss={() => this.setState({ datePickerVisible: false })}
                                                            use12Hours={false}
                                                            minDate={new Date()}
                                                          >
                                                            <List.Item
                                                              className='stm-list-time'
                                                              onClick={() => this.setState({ datePickerVisible: true })}
                                                            >
                                                              <Col
                                                                span={24}
                                                                className='stm-margin-bottom-8 stm-padding-left-12 stm-padding-right-8 stm-display-flex stm-align-items-center stm-justify-content-left stm-height-40'
                                                                style={{
                                                                  fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                                  fontSize: activeTemplate.templateSetting.buttonItem.fontSize,
                                                                  lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize + 2}px`,
                                                                  color: timeDeliver === '' ? activeTemplate.templateSetting.buttonItem.color : activeTemplate.templateSetting.buttonItemSelected.color,
                                                                  border: `1px solid ${timeDeliver === '' ? activeTemplate.templateSetting.buttonItem.borderColor : activeTemplate.templateSetting.buttonItemSelected.borderColor}`,
                                                                  backgroundColor: activeTemplate.templateSetting.buttonItem.backgroundColor
                                                                }}
                                                              >
                                                                <Row className='stm-width-100-percent'>
                                                                  <Col
                                                                    span={20}
                                                                    className='stm-display-flex stm-align-items-center stm-justify-content-left stm-height-40'
                                                                  >
                                                                    {timeDeliver === '' ? webSettting.selectTimeText : timeDeliver}
                                                                  </Col>
                                                                  <Col
                                                                    span={4}
                                                                    className='stm-display-flex stm-align-items-center stm-justify-content-right stm-height-40'
                                                                  >
                                                                    <img
                                                                      src={require('../../assets/image/Clock.svg')}
                                                                      alt='Clock'
                                                                      className='' />
                                                                  </Col>
                                                                </Row>
                                                              </Col>
                                                            </List.Item>
                                                          </DatePicker>
                                                        </LocaleProvider>
                                                      </Row>
                                                    </Col>
                                                  </>
                                                </Row>
                                              </Col>
                                            </Row>
                                          </Col>
                                        </Row>
                                      </>
                                    </Col>
                                    <Col span={1} />
                                  </Row>
                                </>
                                :
                                <>
                                  <Row>
                                    <Col span={24} className='stm-margin-top-150 stm-text-align-center'>
                                      <Spin
                                        spinning={true}
                                        tip={webSettting.loadingDataText}
                                        style={{
                                          fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                          color: activeTemplate.templateSetting.text.color,
                                          fontSize: activeTemplate.templateSetting.text.fontSize
                                        }}>
                                      </Spin>
                                    </Col>
                                  </Row>
                                </>
                            }
                          </>

                          {/* Confirm */}
                          <>
                            {
                              item
                                ?
                                <>
                                  <Row>
                                    <Col
                                      span={24}
                                      className='stm-position-fixed stm-bottom-0 stm-padding-bottom-15 stm-background-white stm-padding-top-15 stm-max-width-500'
                                    >
                                      <Row>
                                        <Col span={1} />
                                        <Col span={22} >
                                          <Button
                                            className='stm-width-100-percent stm-border-radius-4 stm-height-54 stm-margin-bottom-2'
                                            onClick={this.confirm}
                                            style={{
                                              background: activeTemplate.templateSetting.footer.backgroundColor,
                                              fontFamily: activeTemplate.templateSetting.footer.fontFamily,
                                              fontSize: activeTemplate.templateSetting.footer.fontSize,
                                              lineHeight: `${activeTemplate.templateSetting.footer.fontSize + 2}px`,
                                              color: activeTemplate.templateSetting.footer.color
                                            }}
                                          >
                                            {webSettting.confirmText}
                                          </Button>
                                        </Col>
                                        <Col span={1} />
                                      </Row>
                                    </Col>
                                  </Row>
                                </>
                                :
                                null
                            }
                          </>

                        </Content>
                      </>
                      :
                      null
                  }
                </>
              </Layout>
            </>
            :
            null
        }
      </>
    )
  }
}

export default withTranslation()(SingleListConfirm)